import StickyBanner from 'components/Common/StickyBanner';

interface IBusinessPausedBannerProps {
  message: string;
}

const BusinessPausedBanner: React.FC<IBusinessPausedBannerProps> = ({ message }) => {
  return (
    <StickyBanner customClass="!bg-brightOrange !text-white !mt-0 min-h-[50px] py-3">
      <div className="flex flex-col md:flex-row md:items-center justify-center gap-3 px-4 w-full">
        <div className="text-sm text-center flex-1" dangerouslySetInnerHTML={{ __html: message }} />
      </div>
    </StickyBanner>
  );
};

export default BusinessPausedBanner;
